import * as React from 'react';
import Box from '@mui/material/Box';
import { Alert, Button, Chip, CircularProgress, Grid, Typography } from '@mui/material';
import $ from "jquery";
import Common from '../utilities/common';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import { NormalizationProgressItem } from '../models/NormalizationItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Layout from '../components/Utilities/Layout';
import ConsolidateProgressItem from './ConsolidateProgressItemView';
import ConsolidateProgressItemView from './ConsolidateProgressItemView';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntityPermissions from '../components/EntityPermissions';
import EntitySettings from '../components/EntitySettings';
import FeatureManager from '../components/Utilities/FeatureManager';

export interface IConsolidateProgressState {
    data: any[];
    selectedTab: string;
    loading: boolean;
    totalPendiente: number;
    totalActivo: number;
    totalError: number;
    totalFinalizado: number;
}


export default class ConsolidateProgress extends React.Component<{}, IConsolidateProgressState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedTab: 'pendiente',
            loading: true,
            totalPendiente: 0,
            totalActivo: 0,
            totalError: 0,
            totalFinalizado: 0
        };
    }

    componentDidMount(): void {
        this.GetData('pendiente');
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Consolidaciones} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Consolidaciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Consolidaciones',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <StorageOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Consolidaciones
                                    </Typography>
                                </Grid>
                                <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Administrar}>
                                    <Grid item xs={2} className='entitySettings'>
                                        <EntitySettings entity={Entity.Consolidaciones}/>
                                    </Grid>
                                </SecurityTrimmer>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={this.state.selectedTab} onChange={(event: React.SyntheticEvent, newValue: string) => {
                                    this.setState({
                                        loading: true,
                                        selectedTab: newValue
                                    });
                                    this.GetData(newValue);
                                }}>
                                    <Tab label={
                                        <Typography variant='body2'>
                                            Pendiente
                                            <Chip label={this.state.totalPendiente} style={{marginLeft: '5px'}}/>
                                        </Typography>
                                    } value='pendiente'/>
                                    <Tab label={
                                        <Typography variant='body2'>
                                            Activo
                                            <Chip label={this.state.totalActivo}  style={{marginLeft: '5px'}}/>
                                        </Typography>
                                    } value='activo'/>
                                    <Tab label={
                                        <Typography variant='body2'>
                                            Finalizado
                                            <Chip label={this.state.totalFinalizado}  style={{marginLeft: '5px'}}/>
                                        </Typography>
                                    } value='finalizado'/>
                                    <Tab label={
                                        <Typography variant='body2'>
                                            Error
                                            <Chip label={this.state.totalError}  style={{marginLeft: '5px'}}/>
                                        </Typography>
                                    } value='error'/>
                                </Tabs>
                            </Box>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.map((item: any, index: number) => {
                                    return (
                                        <ConsolidateProgressItemView key={index} item={item}/>
                                    )
                                })
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                        </Box>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetData(status: string): void {
        let url = `${Common.END_POINT}/consolidaciones/status/${status}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: ConsolidateProgressItem[]) => {
            console.log(response);
            this.setState(
                {
                    data: response,
                    loading: false
                }
            );

            this.GetTotalActivo();
            this.GetTotalPendiente();
            this.GetTotalFinalizado();
            this.GetTotalError();
        })
    }

    private GetTotalPendiente() {
        let url = `${Common.END_POINT}/consolidaciones/status/pendiente/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalPendiente: response
                }
            );
        })
    }

    private GetTotalActivo() {
        let url = `${Common.END_POINT}/consolidaciones/status/activo/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalActivo: response
                }
            );
        })
    }

    private GetTotalError() {
        let url = `${Common.END_POINT}/consolidaciones/status/error/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalError: response
                }
            );
        })
    }

    private GetTotalFinalizado() {
        let url = `${Common.END_POINT}/consolidaciones/status/finalizado/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    totalFinalizado: response
                }
            );
        })
    }
}